import { Component, Injector, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { Observable, finalize } from 'rxjs';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';

@Component({
    template: '',
    standalone: false
})
export abstract class CdRequestWizardBaseComponent extends ApplicationContextBoundComponent {

  @ViewChild('wizardForm') wizardForm: NgForm;

  abstract steps: MenuItem[];
  abstract wizardTitle: string;

  activeStepIndex: number = 0;
  isStepRunning: boolean = false;
  nextButtonLabel: string = "Next";
  atFirstStep: boolean = true;
  atLastStep: boolean = false;
  disableNextButton: boolean = false;

  submissionStatus: string | null = null;
  submittedDate: Date | null = null;

  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  abstract validateCurrentStep(): boolean;

  abstract onStepChange(fromStep: number, toStep: number): void;

  abstract autoSave(): Observable<any>;

  protected abstract setNextButtonLabel(): void;

  protected abstract handleAutoSaveError(error: any): void;

  navigateForward(): void {
    if (!this.validateCurrentStep()) {
      return;
    }

    const fromStep = this.activeStepIndex;
    const canNavigate = this.activeStepIndex < this.steps.length - 1;

    if (!canNavigate) {
      return;
    }

    this.isStepRunning = true;
    this.autoSave().pipe(
      finalize(() => this.isStepRunning = false)
    ).subscribe({
      next: () => {
        this.activeStepIndex++;
        this.updateCurrentStepRelatedState();
        this.onStepChange(fromStep, this.activeStepIndex);
      },
      error: (err) => {
        this.handleAutoSaveError(err);
        this.activeStepIndex++;
        this.updateCurrentStepRelatedState();
        this.onStepChange(fromStep, this.activeStepIndex);
      }
    });
  }

  navigateBackward(): void {
    if (this.activeStepIndex > 0) {
      const fromStep = this.activeStepIndex;

      this.isStepRunning = true;
      this.autoSave().pipe(
        finalize(() => this.isStepRunning = false)
      ).subscribe({
        next: () => {
          this.activeStepIndex--;
          this.updateCurrentStepRelatedState();
          this.onStepChange(fromStep, this.activeStepIndex);
        },
        error: (err) => {
          this.handleAutoSaveError(err);
          this.activeStepIndex--;
          this.updateCurrentStepRelatedState();
          this.onStepChange(fromStep, this.activeStepIndex);
        }
      });
    }
  }

  protected updateCurrentStepRelatedState(): void {
    this.atFirstStep = this.activeStepIndex === 0;
    this.atLastStep = this.activeStepIndex === this.steps.length - 1;
    this.setNextButtonLabel();
  }
}
